import { ifAgencyDuringOnboarding } from 'app/core/guards/rules/agencyRules';
import { getMainRole, isBackoffice, isClient, isGeneral, isInspector } from 'app/helpers/userRoles';
import { RootState } from 'app/store/rootReducer';
import MessagesBell from 'app/ui/modules/messaging/components/messages-bell/MessagesBell';
import { useSelector } from 'react-redux';

import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';

import ToolbarCallToAction from '../tollbar-call-to-action/TollbarCallToAction';
import { getLogoConfig } from '../toolbar-logo/helpers';
import ToolbarLogo from '../toolbar-logo/ToolbarLogo';
import UserMenu from '../UserMenu';
import UserMenuMobile from '../UserMenuMobile';

export default function ToolbarLogged() {
  const { user, currentApp } = useSelector((state: RootState) => state.auth);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  let messagesDisabled = true;
  if (isClient(user) || isInspector(user) || isBackoffice(user) || isGeneral(user)) {
    messagesDisabled = false;
  } else if (!isBackoffice(user)) {
    messagesDisabled = ifAgencyDuringOnboarding(user);
  }

  return (
    <Toolbar disableGutters>
      <ToolbarLogo textLogoFileConfig={getLogoConfig(currentApp)} />
      <Box flexGrow="1" />
      <Box display="flex" alignItems="center" className="print-hidden">
        <ToolbarCallToAction user={user} currentApp={currentApp} />

        {!messagesDisabled && <MessagesBell userRole={getMainRole(user)} />}

        {!matches && <UserMenu />}
        {matches && <UserMenuMobile />}
      </Box>
    </Toolbar>
  );
}
